import { shadeColor } from '@app/utils/utils';
// import { graphic } from 'echarts';
import { BASE_COLORS } from '../constants';
import { ITheme } from '../types';

// const chartColors = {
//   chartTooltipLabel: '#a9a9a9',
//   chartColor1: '#b3282e',
//   chartColor1Tint: '#d64b52',
//   chartColor2: '#891f27',
//   chartColor2Tint: '#a94046',
//   chartColor3: '#5b5b5f',
//   chartColor3Tint: '#7f7f85',
//   chartColor4: '#FFB155',
//   chartColor4Tint: '#ffc07e',
//   chartColor5: '#30AF5B',
//   chartColor5Tint: '#56ca7b',
//   chartPrimaryGradient: new graphic.LinearGradient(0, 0, 0, 1, [
//     { offset: 0, color: 'rgba(179, 40, 46, 0.4)' },
//     { offset: 1, color: 'rgba(179, 40, 46, 0)' },
//   ]),
//   chartSecondaryGradient: new graphic.LinearGradient(0, 0, 0, 1, [
//     { offset: 0, color: 'rgba(137, 31, 39, 0.4)' },
//     { offset: 1, color: 'rgba(137, 31, 39, 0)' },
//   ]),
//   chartSecondaryGradientSpecular: new graphic.LinearGradient(0, 0, 0, 1, [
//     { offset: 0, color: 'rgba(255, 255, 255, 0)' },
//     { offset: 1, color: 'rgba(137, 31, 39, 0.4)' },
//   ]),
// };

export const darkColorsTheme: ITheme = {
  primary: '#950606', // mantem a cor de fundo das acoes
  primaryText: '#FF7773', // contraste AA para o vermelho usado como texto
  primary1: '#630404', // vinho bem escuro
  primaryGradient: 'linear-gradient(211.49deg, #950606 15%, #630404 49%)',
  privarySelect: '#730505', // suave vermelho para selects
  light: '#888888', // cinza médio
  secondary: '#5b5b5f', // mesmo cinza do light
  error: '#ff5252',
  warning: '#ffb155',
  success: '#30AF5B',
  background: '#181818',
  secondaryBackground: '#212124',
  secondaryBackgroundSelected: shadeColor('#212124', -5),
  additionalBackground: '#252529',
  collapseBackground: '#891f27',
  timelineBackground: '#1e1e22',
  siderBackground: '#121212',
  spinnerBase: '#b3282e',
  scroll: '#404040',
  border: '#4a4a4a',
  borderNft: '#585858',
  textMain: '#f0f0f0',
  textLight: '#b8b8b8',
  textSuperLight: '#8a8a8a',
  textSecondary: '#e1e1e1',
  textDark: '#d4d4d4',
  textNftLight: '#7a7a7a',
  textSiderPrimary: '#FFB765',
  textSiderSecondary: '#a0a0a0',
  subText: 'rgba(255, 255, 255, 0.5)',
  shadow: 'rgba(0, 0, 0, 0.3)',
  boxShadow: '0 2px 8px 0 rgba(0, 0, 0, 0.15)',
  boxShadowHover: '0 4px 16px 0 rgba(0, 0, 0, 0.25)',
  boxShadowNft:
    '0px 16px 24px rgba(0, 0, 0, 0.2), 0px 2px 6px rgba(0, 0, 0, 0.15)',
  boxShadowNftSecondary: '0px 10px 20px rgba(0, 0, 0, 0.15)',
  dashboardMapBackground: '#1e1e22',
  dashboardMapCircleColor: '#4a4a4a',
  dashboardMapControlDisabledBackground: '#343437',
  notificationSuccess: '#1b3224',
  notificationPrimary: '#36161a',
  notificationWarning: '#3b2c1b',
  notificationError: '#3a1818',
  heading: BASE_COLORS.white,
  borderBase: '#5e3e40',
  disable: 'rgba(255, 255, 255, 0.25)',
  disabledBg: '#40404033',
  layoutBodyBg: '#212124',
  layoutHeaderBg: 'transparent',
  layoutSiderBg: 'linear-gradient(261deg, #950606 -29%, #630404 121%)',
  inputPlaceholder: '#8a8a8a',
  itemHoverBg: '#2b2b2f',
  backgroundColorBase: '#212124',
  avatarBg: '#383838',
  alertTextColor: '#ffffff',
  breadcrumb: 'rgba(255, 255, 255, 0.45)',
  icon: '#a9a9a9',
  iconHover: 'rgba(255, 255, 255, 0.85)',
  tableHeaderBackground: 'rgba(255, 255, 255, 0.03)', // tom escuro, sem muito contraste
  tableBorderColor: '#343437',
  tableHoverColor: '#2b2b2f',
  // ...chartColors,
};

export const antDarkColorsTheme = {
  successBg: '#183022',
  successBorder: '#2a4d37',
};
